import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/it";

dayjs.extend(relativeTime);
dayjs.locale("it"); // use locale globally

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Aggiornamento data articoli
	const today = dayjs().format("YYYY-MM-DD");

	for (const article_date of document.querySelectorAll("._article_date")) {
		const pub_date_day = dayjs(article_date.dataset.date, "YYYY-MM-DD").format(
			"YYYY-MM-DD",
		);
		if (pub_date_day === today) {
			const pubdate = dayjs(
				article_date.dataset.date,
				"YYYY-MM-DD HH:mm:ss",
			).fromNow();
			article_date.textContent = pubdate;
		}
	}

	const article_date = document.querySelector("#_article_pub_date");
	if (article_date) {
		const pub_date_day = dayjs(article_date.dataset.date, "YYYY-MM-DD").format(
			"YYYY-MM-DD",
		);
		if (pub_date_day === today) {
			const pubdate = dayjs(
				article_date.dataset.date,
				"YYYY-MM-DD HH:mm:ss",
			).fromNow();
			article_date.textContent = pubdate;
		}
	}
});
